import Overview from '../pages/commandControl/overview/Overview'
import Dashboard from '../pages/commandControl/dashboard/Dashboard'
import CrewMessaging from '../pages/commandControl/messaging/CrewMessaging'
import ScreenLayouts from '../pages/commandControl/layouts/ScreenLayouts'
import Incidents from '../pages/commandControl/incidents/Incidents'
import Resources from '../pages/commandControl/resources/Resources'
import Maps from '../pages/commandControl/maps/Maps'
import LogsDecisions from '../pages/commandControl/logs-decisions/LogsDecisions'
import TreatmentCentres from '../pages/commandControl/treatment-centres/TreatmentCentres'
import Metrics from '../pages/commandControl/metrics/Metrics'
import Permissions from '../pages/commandControl/permissions/Permissions'

export default [
  {
    id: 'overview',
    title: 'Overview',
    pages: [
      {
        id: 'overview',
        title: 'Control Room Overview',
        summary:
          'Understand the live control room workspace, sync model, and core command-control capabilities.',
        component: Overview,
        tags: ['Command', 'Control Room', 'Overview', 'Live Operations'],
      },
      {
        id: 'dashboard',
        title: 'Control Room Dashboard',
        summary:
          'Enter active control rooms, start rooms for events or standalone operations, and monitor beds, incidents, and logs across rooms.',
        component: Dashboard,
        tags: ['Dashboard', 'Start Control Room', 'Custom Control Room', 'Bed Management'],
      },
      {
        id: 'screen-layouts',
        title: 'Screen Layouts',
        summary:
          'Use Compact, Screen 1, and Screen 2 views for single-screen, incident-control, and map-focused operation with the Map, Event, Overlay, and GPX views.',
        component: ScreenLayouts,
        tags: ['Compact', 'Screen 1', 'Screen 2', 'Layout', 'Map View', 'Overlay', 'GPX'],
      },
    ],
  },
  {
    id: 'operations',
    title: 'Operations',
    pages: [
      {
        id: 'incidents',
        title: 'Incidents',
        summary:
          'Create, triage, dispatch, update, search, and map active incidents, with crew alerting and acknowledgement.',
        component: Incidents,
        tags: ['Incidents', 'Dispatch List', 'Ongoing Incidents', 'Priority', 'Call Triage', 'Acknowledgement'],
      },
      {
        id: 'resources',
        title: 'Resources',
        summary:
          'Add resources by call sign or vehicle, manage status, breaks, crew, and location sharing, and dispatch to incidents.',
        component: Resources,
        tags: ['Resources', 'Call Sign', 'Status', 'Break', 'Assignment', 'Location Sharing', 'Vehicles'],
      },
      {
        id: 'crew-messaging',
        title: 'Crew Messaging',
        summary:
          'Message resource crews from the control room, track unread replies, push-notify crews, and record on-incident chat in the incident log.',
        component: CrewMessaging,
        tags: ['Messages', 'Chat', 'Crew', 'Unread', 'Resource Messaging', 'Incident Log', 'Push Notifications'],
      },
      {
        id: 'maps',
        title: 'Maps and Event Maps',
        summary:
          'Use live maps, uploaded event maps, the scaled overlay view, GPX course routes, named map pins, manual placement, and priority-coloured markers.',
        component: Maps,
        tags: ['Map', 'Event Map', 'Markers', 'Coordinates', 'Overlay', 'GPX Routes', 'Map Pins'],
      },
    ],
  },
  {
    id: 'command-record',
    title: 'Command Record',
    pages: [
      {
        id: 'logs-and-decisions',
        title: 'Logs and Complex Decisions',
        summary:
          'Record command logs, system changes, incident-linked logs, the tactical log with PDF export, and complex decisions.',
        component: LogsDecisions,
        tags: ['Command Logs', 'System Logs', 'Incident Logs', 'Complex Decisions', 'Tactical Log'],
      },
      {
        id: 'metrics',
        title: 'Metrics',
        summary:
          'Review live metrics, ePCR counts, patient outcomes, presenting complaints, and multi-day event filters.',
        component: Metrics,
        tags: ['Metrics', 'ePCR', 'Patients', 'Multi-day Events'],
      },
    ],
  },
  {
    id: 'clinical-flow',
    title: 'Clinical Flow',
    pages: [
      {
        id: 'treatment-centres',
        title: 'Treatment Centres',
        summary:
          'Configure treatment centres, review centre summaries, manage patient flow, and open a treatment location as a shared-tablet workstation with the workstation lock.',
        component: TreatmentCentres,
        tags: ['Treatment Centres', 'Treatment Locations', 'Patients', 'Capacity', 'Workstations', 'Bed Board', 'Workstation Lock'],
      },
    ],
  },
  {
    id: 'administration',
    title: 'Administration',
    pages: [
      {
        id: 'permissions-and-audit',
        title: 'Permissions and Audit',
        summary:
          'Understand the Viewer, Call Taker/Dispatcher, and Commander tiers, view-only mode, audit trails, and closing/reopening rooms.',
        component: Permissions,
        tags: ['Permissions', 'Viewer', 'Dispatcher', 'Call Taker', 'Commander', 'View Only', 'Audit', 'Close Control Room'],
      },
    ],
  },
]
